const INITIAL_STATE = {
  tryRedirect: false,
  showFilters: true
};

const SearchClubData = {
  INITIAL_STATE,
}

export default SearchClubData;